import { Link } from 'react-router'
import type { SplitButtonSize } from '../buttons/split-button.tsx'
import type { BeaconPill } from './beacon-run.ts'
import * as styles from './beacon-scanning-pill.css.ts'

export type BeaconScanningPillProps = {
  pill: BeaconPill
  /** Where the pill leads — the run's page. Without it the pill is a plain status. */
  to?: string
  size?: SplitButtonSize
}

/**
 * A run's one-line status — "Scanning · 3 of 6 lenses", "Verifying · 12 of 76" — over a fill that tracks
 * how far the current step has got.
 */
export const BeaconScanningPill: React.FC<BeaconScanningPillProps> = ({ pill, to, size = 'default' }) => {
  const content = (
    <>
      <span className={styles.dot({ tone: pill.tone })} aria-hidden />
      <span className={styles.label}>{pill.label}</span>
      {pill.tone === 'running' && (
        <span className={styles.track} aria-hidden>
          <span className={styles.fill} style={{ width: `${Math.round(pill.fraction * 100)}%` }} />
        </span>
      )}
    </>
  )
  const className = styles.pill({ tone: pill.tone, size, isLink: !!to })

  return to ? (
    <Link to={to} className={className} aria-label={`${pill.label} — open the Beacon run`}>
      {content}
    </Link>
  ) : (
    <span className={className} role="status">
      {content}
    </span>
  )
}
